import { FC } from "react";

import { ShoppingTypeFilterProps } from "~/bff/components/ShoppingTypeFilter";
import {
  BffComponentType as Component,
  ComponentsConfig,
} from "~/bff/ComponentsConfig";
import { ShopFilter } from "~/components/products-layout/components/products-filters/components/filter/components/shop-filter/component";

export const shoppingTypeFilterComponentConfig: ComponentsConfig = {
  [Component.SHOPPING_TYPE_FILTER]: {
    component: ShopFilter as FC<ShoppingTypeFilterProps>,
  },
};
